import React, { useState, useContext, useRef} from "react";

import {View, Text}  from 'react-native';

import {useNavigation} from '@react-navigation/native'

import {estilos} from '../util/estilos'

import * as util from '../util/util'

import {buscar_loja} from '../ws/ws_usuarios'

import contexto from '../util/contexto'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import { useFocusEffect } from '@react-navigation/native';

import {semDados} from '../componentes/SemDados'

import {carregamento} from '../componentes/Carregamento'

import { BackHandler } from 'react-native';

import {USER_TIPO_PJ, TELA_LOGIN, TELA_LOJA} from '../util/constantes'

import {WS_URL_LOJA} from '../util/params'

import * as validacao from '../util/validacao'

import FormularioSelecionarItem, {TIPO_LOJA_ITEM} from '../componentes/FormularioSelecionarItem'

import Bloco from '../componentes/Bloco'

import Imagem from '../componentes/Imagem'





export default function TelaLoja({ route }){
   
	const {valorContexto} = useContext(contexto);

	const [sincronizando, setSincronizando] = useState(true) 
	
	const [loja, setLoja] = useState(null) 
	
	const navegacao = new useNavigation();
	
	const formularioSelecionarItem  = useRef(null)
	
	const codigo = route!=null && route.params!=null? route.params.codigo:null;

	const voltar = () => {

		if(util.temConteudo(codigo))
			navegacao.replace(TELA_LOGIN)
		else
			navegacao.navigate(util.processaVoltar())
		
		return true;
	};


	useFocusEffect(React.useCallback(() => {

		util.print("TelaLoja "+codigo);
		
		BackHandler.addEventListener('hardwareBackPress', voltar);
		
		buscarDados();
		
		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};
		
	}, []));
	
	
	const buscarDados= async ()=>{

		setSincronizando(true);
		
		setLoja(await buscar_loja(valorContexto.idLoja!=null? parseInt(valorContexto.idLoja): null, codigo+""));
	
		setSincronizando(false)
	}
	
	
	function topo(){
		
		return (
			<Bloco>             			
				<View style={{marginTop:20}}/>  
							
				<View style={{alignItems:'center'}}>
							
					<Imagem imagem={loja.imagem} tamanho={160} redondo={true}/>		
								
					<View style={{marginTop:20}}/> 
									
					<View style={{alignItems:'center'}}>
						<Text style={estilos.rotulo_titulo}>{loja.nome}</Text>	    
					</View>
						
					{loja.tipo == USER_TIPO_PJ && 
						<View style={{alignItems:'center'}}>
							<View style={{marginTop:10}}/> 
							<Text style={estilos.rotulo_padrao}>{validacao.formataCnpj(loja.cpf_cnpj)}</Text>	    
						</View>
					}
								
					<View style={{marginTop:10}}/> 

					<Text style={estilos.rotulo_padrao}>{loja.email}</Text>
					
					<View style={{marginTop:30}}/> 
					
					{util.temConteudo(loja.codigo) && 
						<View style={{alignItems:'center'}}>
							<Text style={estilos.rotulo_padrao}>Link da Loja:</Text>
							<Text style={estilos.rotulo_padrao}>{WS_URL_LOJA}{loja.codigo}</Text>
						</View>
					}	

					<View style={{marginTop:10}}/> 
				</View>
			</Bloco>
		)
	}
	
	
	return (
		<ViewDegradeVertical titulo="Loja Virtual" voltar={()=>voltar()}>  
			{ (sincronizando) ?
				(carregamento(sincronizando)):
				(loja ==null?
					(<Bloco todaArea={true}> 
						{semDados("info", "Loja virtual não encontrada", 60)}
						<View style={{marginTop:10}}/>	
					</Bloco>):
					(<FormularioSelecionarItem ref={formularioSelecionarItem} 
											tipo={TIPO_LOJA_ITEM}
												topo={topo()}
												idUsuario={loja.id!=null?parseInt(loja.id):null}
												voltarPara={TELA_LOJA}/>)
				)	
			} 
        </ViewDegradeVertical>
	)
}